import classes from '../Card.module.scss'
import { CardImage } from '../CardImage';

export function CardTextImage({ cardData }) {
    return (
        <>
        <CardImage
            cardData={cardData} 
        />
        <div className={classes.card__caption}>
            {cardData.text}
        </div>
        </>
    )
}

// CardTextImage.propTypes = {
//     imageSrc: PropTypes.string.isRequired,
//     text: PropTypes.string.isRequired
// }